import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { lastValueFrom, Observable } from 'rxjs';
import { IQuestionModel } from "src/app/models/communication/questions";
import { IRelatedSusar, ISignatureList, ISusarGridReport, ISusarRecord, SiteSafetyReportViewModel, SiteUserSafetyReportRequest, SRType, SusarSigner } from '../models/communication/safetyreports';
import { RoutingService, PortalService } from "src/app/services";
import { IAlertGridReport } from '../models/communication/message';
import { Guid } from 'guid-typescript';

@Injectable({ providedIn: 'root' })
export class CommunicationService {
  private COMMUNICATION_SERVICE_URL = environment.communicationService.url + environment.communicationService.apiVersion;
  private TRIPORTCORE_SERVICE_URL = environment.triportCoreService.url + environment.triportCoreService.apiVersion;
  constructor(
    private http: HttpClient,
    private routingService: RoutingService,
    private portalService: PortalService,
  ) {
  }

  getQuestionLogs(sponsor: string, portalid: number) {
    return new Promise<Array<any>>((resolve, reject) => {
      lastValueFrom(this.http.get(this.COMMUNICATION_SERVICE_URL + "Question/" + sponsor + "/" + portalid, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getQuestionLogById(sponsor: string, portalid: number, messageId: number) {
    return new Promise<Array<any>>((resolve, reject) => {
      lastValueFrom(this.http.get(this.COMMUNICATION_SERVICE_URL + "Question/" + sponsor + "/" + portalid + "/" + messageId, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getMessageCategoriesByPortalID(sponsor: string, portalid: number) {
    return new Promise<Array<any>>((resolve, reject) => {
      lastValueFrom(this.http.get(this.COMMUNICATION_SERVICE_URL + "Question/Category/" + sponsor + "/" + portalid + "/", {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  submitQuestion(sponsor: string, portalid: number, questionModel: IQuestionModel) {
    let body = JSON.stringify(questionModel);
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post(this.COMMUNICATION_SERVICE_URL + "Question/" + sponsor + "/" + portalid, body))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getSignatureList(sponsor: string, portalid: number, assetId: number) {
    return new Promise<ISignatureList>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/signature/" + sponsor + "/" + portalid + "/" + assetId, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  getsitesignatureList(sponsor: string, portalid: number, assetId: number,siteID:number) {
    return new Promise<ISignatureList>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/sitesignature/" + sponsor + "/" + portalid + "/" + siteID + "/" + assetId, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  getSignatureListForSiteView(sponsor: string, portalid: number, siteId: number, assetId: number) {
    return new Promise<ISignatureList>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/sitesignature/" + sponsor + "/" + portalid + "/" + siteId + "/" + assetId, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  postEpaSignature(assetId: number) {
    return new Promise<boolean>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/PostEpaSignature/" + this.routingService.getSponsorName() + "/" + this.portalService.portalConfiguation?.value.PortalID!, assetId))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getBulkSignatureAssetDetails() {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/GetBulkSignatureAssetDetails/" + this.routingService.getSponsorName() + "/" + this.portalService.portalConfiguation?.value.PortalID!))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  postBulkSignature(assetIds: Array<number>) {
    return new Promise<boolean>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/BulkSignature/" + this.routingService.getSponsorName() + "/" + this.portalService.portalConfiguation?.value.PortalID!, assetIds))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  getDilText(sponsor: string, portalid: number, dilId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/Dil/" + sponsor + "/" + portalid + "/" + dilId, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  downloadFile(sponsor: string, portalId: number, susarId: number, siteId:number, downloadAsZip: boolean = false,UpdateStatus : boolean ) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/download/" + sponsor + "/" + portalId + "/" + susarId + "/" + siteId + "/" +UpdateStatus+ "/" + downloadAsZip, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  downloadOriginalFile(sponsor: string, portalId: number, AssetId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/getsusarfilebytes/" + sponsor + "/" + portalId + "/" + AssetId + "/0" , {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  getSusarUrl(susarId: number, updateStatus: boolean,siteId:number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/NonTrackedSusarDocument/" + this.routingService.getSponsorName() + "/" + this.portalService.portalConfiguation?.value.PortalID! + "/" + susarId + "/" + siteId+ "/" + updateStatus, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  updateSusarStatusPromise(susarId: number,siteId?: number): Observable<any> {
    return this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/NonTrackedSusarDocument/" + this.routingService.getSponsorName() + "/" + this.portalService.portalConfiguation?.value.PortalID! + "/" + susarId + "/"+ siteId +"/true", {});
  }
  getSusarUrlForDIL(susarId: Guid) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/GetDILPdfInfo/" + this.routingService.getSponsorName() + "/" + this.portalService.portalConfiguation?.value.PortalID! + "/" + susarId, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  downloadSusarDIL(DILStorageID: Guid) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/downloaddil/" + this.routingService.getSponsorName() + "/" + this.portalService.portalConfiguation?.value.PortalID! + "/" + DILStorageID, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  getRelatedSusar(sponsor: string, portalid: number, susarId: number, selectedSiteId:number) {
    return new Promise<IRelatedSusar>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/RelatedSusar/" + sponsor + "/" + portalid + "/" + susarId + "/" + selectedSiteId, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getAlerts(sponsor: string, portalid: number, sortOptions: any) {
    return new Promise<IAlertGridReport>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.COMMUNICATION_SERVICE_URL + "Message/" + sponsor + "/" + portalid + "/", sortOptions))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getAlertDetails(sponsor: string,portalId:number, mid: string) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "Message/" + sponsor + "/" + portalId + "/" + mid))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  getSiteSusarChartBySiteId(sponsor: string, portalId: number, siteId: number) {
    return new Promise<SiteSafetyReportViewModel>((resolve, reject) => {
      lastValueFrom(this.http.get<SiteSafetyReportViewModel>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/SiteSafetyReportDetails/" + sponsor + "/" + portalId + "/" + siteId))
        .then(
          (response?: SiteSafetyReportViewModel) => {
            resolve(response!);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  getSiteUserSafetyReportsGrid(sponsor: string, portalid: number, siteUserSafetyReportRequest: SiteUserSafetyReportRequest) {
    return new Promise<ISusarRecord[]>((resolve, reject) => {
      lastValueFrom(this.http.post<ISusarRecord[]>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/SiteSafetyReports/" + sponsor + "/" + portalid, siteUserSafetyReportRequest))
        .then(
          (response?: ISusarRecord[]) => {
            resolve(response!);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  checkSignaturePermission(sponsor: string, portalId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/CanSign/" + sponsor + "/" + portalId))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  getDelegatedSigner(sponsor: string, portalId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/IsDelegateSigner/" + sponsor + "/" + portalId))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  
  getSRType(sponsor: string, portalid: number,siteid : number){
    
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<SRType[]>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/SafetyReportCompletionByType/" + sponsor + "/" + portalid + "/" + siteid))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
getIsExemptedSite(sponsor: string,siteid : number){
    
  return new Promise<any>((resolve, reject) => {
    lastValueFrom(this.http.get<SRType[]>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/IsExemptedSite/" + sponsor + "/" + siteid))
      .then(
        (response?: any) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}
GetSafetyReportForEnterprisePortal(sponsorName: string,portalId : number,susarTypeID:number){
  return new Promise<boolean>((resolve, reject) => {
    lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/EnterpriseSafetyReport/" + sponsorName +"/" +portalId +"/" + susarTypeID,{}))
      .then(
        (response?: any) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}  
GetSafetyReportsBySRTypeId(sponsorName: string,portalId : number,siteId:number,susarTypeId:number) {
  return new Promise<boolean>((resolve, reject) => {
    lastValueFrom(this.http.post<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/SiteSafetyReports/" + sponsorName +"/" +portalId +"/" + siteId + "/"+susarTypeId,{}))
      .then(
        (response?: any) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}
getSafetyReports(sponsor: string, portalid: number, susarTypeID:number) {
  return new Promise<ISusarGridReport>((resolve, reject) => {
    lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/" + sponsor + "/" + portalid + "/" + susarTypeID, {}))
      .then(
        (response?: any) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}
getSiteSigners(sponsor: string, portalid: number, siteId:number) {
  return new Promise<SusarSigner>((resolve, reject) => {
    lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/SiteSigners/" + sponsor + "/" + portalid + "/" + siteId, {}))
      .then(
        (response?: any) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}
InsertManageSiteSigners(sponsor: string, portalid: number, siteId: number,userId :number) {
  
  return new Promise<any>((resolve, reject) => {
    lastValueFrom(this.http.put(this.COMMUNICATION_SERVICE_URL + "SafetyReport/ManageSiteSigners/" + sponsor + "/" + portalid+ "/" + siteId + "/" + userId, {}))
      .then(
        (response?: any) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}
DeleteManageSiteSigners(sponsor: string, portalid: number, siteId: number,userId :number) {
  
  return new Promise<any>((resolve, reject) => {
    lastValueFrom(this.http.delete(this.COMMUNICATION_SERVICE_URL + "SafetyReport/ManageSiteSigners/" + sponsor + "/" + portalid + "/" + siteId + "/" + userId, {}))
      .then(
        (response?: any) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

  getSusarExportDataBySiteID(sponsor: string, portalid: number, siteId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/SusarExport/" + sponsor + "/" + portalid + "/" + siteId, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  exportInsert(sponsor: string, portalid: number, insertExport: any ) {
    return new Promise<any>((resolve, reject) => {      
      lastValueFrom(this.http.post<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/SusarExportInsert/" + sponsor + "/" + portalid, JSON.stringify(insertExport)))
        .then((data: any) => {
          resolve(data);
        },
          (err) => {
            reject(err);
          });
    });
  }

  downloadBatchExportRequest(sponsor: string, portalId: number, fileGuid: Guid) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/DownloadBatchExportRequest/" + sponsor + "/" + portalId + "/" + fileGuid, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  hasUserExceededSusarExportLimit(sponsor: string, portalid: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMUNICATION_SERVICE_URL + "SafetyReport/HasUserExceededSusarExportLimit/" + sponsor + "/" + portalid, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
}
